module.exports = __webpack_public_path__ + "static/logo-dark-2ce8609154c09af7d8a4f6f57725f75a.png";